const { replaceBrandVars } = require('./replace-brand-vars')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} brand
 * @param {string} country
 * @param {*} content
 * @param {string} content.label
 * @param {string} content.error
 * @param {string} content.tooltipTitle
 * @param {string} content.tooltipText
 * @param {object} form
 * @param {string} locale
 * @returns {{tooltipTitle: *, tooltipText: *, label: *, error: *}}
 */
function replaceFormFieldContent ({ brand, country, content, form, locale } = {}) {
  const output = {
    label: content?.label,
    error: content?.error,
    tooltipTitle: content?.tooltipTitle,
    tooltipText: content?.tooltipText
  }

  if (!brand || !country) return output

  output.label = replaceBrandVars({ brand, country, content: output.label, form, locale })
  output.error = replaceBrandVars({ brand, country, content: output.error, form, locale })
  output.tooltipTitle = replaceBrandVars({ brand, country, content: output.tooltipTitle, form, locale })
  output.tooltipText = replaceBrandVars({ brand, country, content: output.tooltipText, form, locale })

  return output
}

module.exports = { replaceFormFieldContent }
